<template>
  <page-template >
    <template slot="page-content">
      <div class="generic--template page-template">
        <!-- PAGE BG -->
        <!-- <div class="db fixed top-0 bottom-0 w-100 vh-100 bg-cream z-2"></div>
        <div v-if="page.background_color" class="db fixed top-0 bottom-0 w-100 vh-100 z-2" :style="{opacity: (1.1 - bgOpaciy), 'background-color': page.background_color }"></div>
        <div v-else class="db fixed top-0 bottom-0 w-100 vh-100 bg-blue z-2" :style="{opacity: (1.1 - bgOpaciy), 'background-color': '#A6CBCB' }"></div> -->

        <h1 class="is-navy is-blenny soma-header lh-heading f-page-title center">{{ page.seo_title }}</h1>
            <div class="" v-if="page.admat_section.is_link_out">
              <!-- <a
                :href="page.admat_section.link"
                v-if="page.admat_section.header_text && page.admat_section.link"
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                v-html="marked(page.admat_section.header_text)"
                target="_blank"
              ></a>
              <a
                href="https://outsidelands.shop.musictoday.com/store/"
                v-else
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                target="_blank"
                >{{ page.admat_section.header_text }}</a
              > -->
            </div>
            <div class="" v-else>
              <!-- <router-link
                :to="page.admat_section.link"
                v-if="page.admat_section.header_text && page.admat_section.link"
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                v-html="marked(page.admat_section.header_text)"
              ></router-link>
              <router-link
                to="/tickets"
                v-else
                class="db relative mb4 center f4 f3-ns is-ls-1 is-lorano-bold is-navy link tc"
                >{{ page.admat_section.header_text }}</router-link
              > -->
            </div>
            <!-- <a class="db relative ph4 ph5-ns pv4 pv5-ns pointer bg-navy bg-bows-blue">-->
            <span
              class="db relative pt0 pt4-ns pb4 pointer admat-night"
              
            >
              <img
                v-show="isWindowWidthMobile"
                class="db dn-ns relative "
                v-lazy="page.admat_section.mobile_image"
              />
              <img
                v-show="!isWindowWidthMobile"
                class="dn db-ns relative  admat-regular admat-small"
                v-lazy="page.admat_section.desktop_image"
              />
              
            </span>
            <p class="f22px padding-ugh2 is-tablet-regular link-bold lh-copy" v-html="marked(page.intro_text)"></p>
            <!-- <a :href="page.lineup_button.link">{{page.lineup_button.copy}}</a> -->
            <!-- <router-link
              class="db relative center mw6 ph4 btn-primary has-red-bg"
              :to="page.lineup_button.link"
            >
              <span class="text">
                {{ page.lineup_button.copy }}
              </span>
            </router-link> -->
          </section>
          <div class="pic-left3">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/Fork_Knife Icon/Fork_Knife_Icon_SVG/Fork_Knife_Icon_Blue.svg"
                  /> -->
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/Tree-(Night)-Icon/Tree-(Night)-Icon-SVG/TreeNight_Icon_Infrared.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon-2 icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg"
                  />
                  <!-- <img
                    v-scrollanimation
                    class="mw21rem pic-margin"
                    src="/uploads/NUM-BEER/OUTSIDE-BEER-3.jpg"
                  /> -->
                </div>
              </div>
              <div class="pic-right3">
                <div
                  v-scrollanimation
                  class="dn db-ns bigger-img icon-image relative nt4 nl5-ns"
                >
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/Tree-(Night)-Icon/Tree-(Night)-Icon-SVG/TreeNight_Icon_Infrared.svg"
                  />
                  <img
                    v-scrollanimation
                    class="mw21rem icon icon-margin"
                    src="/uploads/OL20-OL21_Icons/DJ_Icon/DJ_Icon_SVG/DJ_Icon_Infrared.svg"
                  />
                  
                </div>
              </div>

         <!-- CONTENT -->
        <!-- <div class="relative z-content">
          <img class="absolute" :style="calcParallax('tasteBubble', 300, 500, 'right:-70px')" src="/uploads/tastebubble.svg" ref="tasteBubble" />
          <img class="absolute" :style="{'top':parallax + 'px', 'display': 'none'}" src="" />
        </div> -->

        <div class="relative z-content pt4">
          <div class="relative container-fluid mw9 center">
            <div class="row relative center tl">   
              <h1 class="f1 is-navy tl lh-title f2 f1-ns is-lorano-bold">{{ page.title }}</h1>
            </div>
          </div>
          <section class="relative pb5">
            <div class="relative container-fluid mw9 center">
              <div class="row">
                <div class="col-xs-12 col-sm-3" v-for="(show, index) in page.shows" :key="'night-show-' + index">
                  <a class="db relative ph2 mv4 mv3 link pointer zoom-hover" :href="show.cta_link.link" target="_blank" :title="show.title">
                    <div class="aspect-ratio--16x9 center zoom-hover-image" v-lazy:background="show.image"></div>  
                  </a>        
                  <div class="mv3 f5 f4-ns is-tablet-bold no-hover is-black">
                    <span class="is-orange" >{{ show.venue }}</span> | <span class="is-black">{{ show.date_type }}</span> | <span class="is-black">{{ show.age }} </span> | <span class="is-black">{{ show.price }}</span>
                  </div>
                  <span class="smaller-pop" v-if="show.sold_out"><em>(SOLD OUT)</em><br/></span>
                  <h3 class="mv2 f3 f2-ns is-tablet-wide-bold is-black" v-html="marked(show.headliner)"> 

                  </h3>
                  <div class="mv3">
                    <h3 class="mv1 f4 f3-ns is-tablet-wide-bold is-black" v-for="(act, index) in show.supporting_acts" :key="'supportin-act-' + index"> 
                      {{ act.title }}
                    </h3>
                  </div>
                  
                    <h3 class="mv1 smaller-pop f3-ns is-tablet-wide is-black" v-html="marked(show.health)"> 
                      
                    </h3>
                    <h3 class="mv1 smaller-pop f3-ns is-tablet-wide is-black" v-if="show.benefit" > 
                      * <em>100% of ticket sales will be donated to benefit SF Rec & Park</em>
                    </h3>
        
                  <a class="mv3 f4 link pointer is-tablet-bold is-orange no-hover hover-link" :href="show.cta_link.link" target="_blank" :title="show.title">{{ show.cta_link.title }} <div class="checkout simple-svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.138 11.234" class="simple-svg"><g fill="none" stroke="#ff6148" stroke-linecap="round" stroke-width="3"><path d="m5.462 0-5.462 4.054 5.462 4.18" stroke-linejoin="round" transform="matrix(-1 0 0 -1 15.638 9.734)"></path><path d="m15.638 5.576h-14.138"></path></g></svg></div></a>



                </div>

              </div>
            </div>
          </section>
          <!-- <div class="w-100 pb5 flex flex-column z-content">
            <div class="bg-blue-after pv5 relative">
              <div class="flex flex-column container-fluid relative z-4">
                <h2 class="f30px is-white center tc ttu lh-copy is-lorano-bold pv4 dib">WE’LL SEND YOU THE LATEST.<img class="dib megaphone" src="/uploads/OL19_Megaphone.svg" /></h2>
                <signup-form class="w-100 mw6 dib form-is-blue"></signup-form>
              </div>
            </div>
          </div> -->
        </div>

      </div>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from './page-template.vue';
import SignupForm from './signup-form.vue';
export default {
  components: {
    PageTemplate,
    SignupForm,
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ` + this.$site_seo_title_suffix : this.$site_seo_title_suffix;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      bgOpaciy: 0,
      bgScrollStart: this.$bgScrollStart,
      scrollPos: 0,
      parallax:null,
      parallax2:true,
      window: {
        width: 0,
        height: 0
      },
      isWindowWidthMobile: null,
      swiperOptions: {
          autoplay: {
            delay: 7000,
          },
          speed: 800,
          autoplayDisableOnInteraction: false,
          // loop: true,
          initialSlide: 0,
          //pagination: '.swiper-pagination',
          paginationClickable: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: false,
          },
          keyboardControl: true,
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // },
          initialSlide: 0,
          spaceBetween: 15,
          freeMode: false,
          slidesPerView: 1.3,
        }
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('night-shows.markdown');
      return pageData[0];
    },
    swiper() {
      if(this.$refs.mySwiper)
        return this.$refs.mySwiper.swiper
    },
  },
  methods : {
    scrollBg: function() {
      //console.log('scrollBg');
      if (window.scrollY > this.bgScrollStart) {
        //console.log('scrollBg', window.scrollY, this.bgOpaciy);
          if ((document.body.getBoundingClientRect()).top > this.scrollPos) {
            //this.bgOpaciy = 0 + (1 - window.scrollY * 0.001);
            if (window.scrollY > this.bgScrollStart) {
              this.bgOpaciy = (window.scrollY * 0.001);
              //console.log('SCROLL UP: ', window.scrollY, this.bgOpaciy);
            }
            else {
              this.bgOpacity = 0;
            }
          }
          else {
            //this.bgOpaciy = this.bgOpaciy - (window.scrollY * (0.0001));
            this.bgOpaciy = (window.scrollY * 0.001);
            //console.log('SCROLL DOWN: ', window.scrollY, this.bgOpaciy);
          }
          // saves the new position for iteration.
          this.scrollPos = (document.body.getBoundingClientRect()).top;
      }
      else {
        this.bgOpaciy = 0;
      }
    },
    sizing: function(){
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width < 768)
        this.isWindowWidthMobile = true; 
      else{
        this.isWindowWidthMobile = false; 
        this.mobileActive = -1;
      }
      this.scrollBg();
      if(this.swiper)
        this.swiper.update();
    },
    calcParallax: function(myTarget, offset, movement, positioning){
      if(this.$refs[myTarget]){
        this.parallax2 = false;
        if((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + this.$refs[myTarget].getBoundingClientRect().height) + movement > 0 && (this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset) - movement  < window.innerHeight){
          var newMovement = offset + (((this.$refs[myTarget].parentElement.getBoundingClientRect().y + offset + (this.$refs[myTarget].getBoundingClientRect().height / 2) - (window.innerHeight / 2) - 27) / window.innerHeight) * movement);
          return 'top:'+newMovement+'px;'+positioning;
        } else {
          return 'display:none;';
        }
      }
    },
  },
  created() {
    var w = window.innerWidth;
    if (w < 768) {
      this.isWindowWidthMobile = true; 
    }
    else {
      this.isWindowWidthMobile = false; 
    }
    window.addEventListener('resize', this.sizing);
    window.addEventListener('scroll', this.scrollBg);
    window.addEventListener('load', this.sizing);
  },
  beforeMount() {
    //
  },
  mounted() {
    setInterval(() => {
      if(this.parallax2 !== false)
        this.parallax = this.parallax + 0.02;
    }), 10;
    this.$nextTick(() => {
      //
    })

  },
  beforeRouteUpdate (to, from, next) {
    //
    // don't forget to call next()
  },
  beforeDestroy() {
    var elem = this.$refs.embedContainer.children[1];
    //console.log('elem: ', this.$refs.embedContainer.children[1]);
    elem.parentNode.removeChild(elem);

    var doStuffJs = document.getElementById('ds-fest-lineup-js');

    //console.log('beforeDestroy - 2', doStuffJs);
    doStuffJs.parentNode.removeChild(doStuffJs);
    
    var doStuffFestJs = document.getElementById('ds-fest');
  },
  destroyed() {
    window.removeEventListener('resize', this.sizing);
    window.removeEventListener('scroll', this.scrollBg);
    window.removeEventListener('load', this.sizing);
  }
}
</script>
